import { Injectable } from '@angular/core';
import { Item } from '../../models';
import { ApiClient } from '../api.client';
import { Observable } from 'rxjs';
import { MonthlyRevenueRecord } from '../../models/monthtly-revenue';
import { StoredFile } from '../../models/StoredFile';

@Injectable()
export class ItemService {
  API_URL = 'http://localhost:8080/';

  constructor(private http: ApiClient) {}

  public getWithHireHistory(
    productId: number,
    itemId: number
  ): Observable<Item> {
    return this.http.get<Item>(
      `products/${productId}/items/${itemId}?with[]=hireItems.docket.customer`
    );
  }

  public addItem(productId: number, item: Item) {
    return this.http.post<Item>(`products/` + productId + '/items', item);
  }

  public updateItem(productId: number, itemId: number, item: Partial<Item>) {
    return this.http.put(`products/` + productId + '/items/' + itemId, item);
  }

  public deleteItem(productId: number, itemId: number) {
    return this.http.delete(`products/${productId}/items/${itemId}`);
  }

  findItemByCode(value: string): Observable<Item[]> {
    return this.http.get(
      `items/get-by-code/${encodeURIComponent(value)}?with=product.category`
    );
  }

  get(id: number, withs: string[]) {
    const qs = withs.length ? this.http.getWiths(withs) : ``;
    return this.http.get<Item>(`items/${id}${qs}`);
  }

  mergeItem(itemId: number, destinationId: number) {
    return this.http.put(`items/${itemId}/merge`, {
      destination_item_id: destinationId
    });
  }

  getMonthlyRevenueForProduct(number: number) {
    return this.http.get<MonthlyRevenueRecord[]>(
      `products/${number}/monthly-revenue`
    );
  }

  addItemAttachment(
    itemId: any,
    { file, description }: { file: File; description: string }
  ) {
    const formData = new FormData();
    formData.append('file', file);
    formData.set('description', description);
    return this.http.post<StoredFile>(`items/${itemId}/attachments`, formData);
  }

  getItemAttachments(itemId: number) {
    return this.http.get<StoredFile[]>(`items/${itemId}/attachments`);
  }

  deleteAttachment(itemId: number, attachmentId: number) {
    return this.http.delete(`items/${itemId}/attachments/${attachmentId}`);
  }

  findItemByUUID(uuid: string) {
    return this.http.get<Item>(`items/get-by-uuid/${uuid}`);
  }
}
